import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Message, SpinnerService } from "shared-components";
import { ExpedicionesService } from "../../../services/expediciones.service";

@Component({
  selector: "app-confecciones",
  templateUrl: "./confecciones.component.html",
})

export class ConfeccionesComponent implements OnInit {
    @Input() expedicionId: number;

    public confecciones;
    private _filters;

    // Paginación
    public itemsPerPage = 10;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    // Ordenación
    public orderBy: string;
    public columnId: string;

    public showError = false;
    public mensajes = new Array<Message>();

    constructor(
        private readonly _translate: TranslateService,
        private readonly _spinnerService: SpinnerService,
        private readonly _expedicionesService: ExpedicionesService
    ) {}

    ngOnInit(): void {
        this.getConfecciones();
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    private getConfecciones() {
        this._filters = {
            ...this._filters,
            certificadoExpedicionId: this.expedicionId,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };

        this._spinnerService.showSpinner();
        this._expedicionesService.getExpedicionesConfeccionesDetail(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.confecciones = resp.lista;
            this.totalItems = resp.paginacionMeta.totalCount;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public pageChange(page) {
        this._filters.numPagina = this.currentPage = page - 1;
        this.getConfecciones();
    }

    public itemsPerPageChange(items) {
        this._filters.numPagina = this.currentPage = 0;
        this._filters.tamPagina = this.itemsPerPage = items;
        this.getConfecciones();
    }

    public toOrderBy(columnFilter: string, colId: string) {
        this.columnId = colId;

        if (this.confecciones && this.confecciones.length > 0 && 
            this._filters) {
            const isAscending  = !this.orderBy || this.orderBy.includes('DESC');
            this.orderBy = isAscending ? 'ASC' + colId : 'DESC' + colId;
            this._filters.orderItems = [
                {
                    orderProperty: columnFilter,
                    orderByDescending: !isAscending
                }
            ];
            this.getConfecciones();
        }
    }

    public getIcon(colId: string) {
      let iconClass = 'fa fa-sort';

      if (this._filters?.orderItems && this.columnId === colId) {
          iconClass = this._filters.orderItems[0]?.orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public trackByConfeccionId(index: number, confeccion: { id: number }): number {
        return confeccion.id;
    }
}